<form class="w-100 h-100 form" [formGroup]="bannerForm" (ngSubmit)="sendData()">
  <h4 class="text-center">{{!this.bannerInfo.id ? 'Nuevo' : 'Editar'}} Banner</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-4 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img mb-4" [src]="fileImg643 | safeDom" alt="img-banner" *ngIf="fileImg643">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo3" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg643 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize3">
              Elegir imagen Modal de 600px x 700px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize3">{{wrongSize3}}</span>
          </label>
          <input id="file-upload-logo3" type="file" accept="image/*" (change)="getBase64($event,'img3','img643',3)" />
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="row">
        <div class="col-4">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Título</mat-label>
              <input matInput placeholder="Título" formControlName="title" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>URL a Redireccionar desde Modal</mat-label>
              <input matInput placeholder="URL a Redireccionar desde Modal" formControlName="urlModal">
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-4">
          <div>
            <h5 class="m-0 font-weight-bold">¿Por defecto?</h5>
          </div>
          <mat-button-toggle-group #defaultExist="matButtonToggleGroup" (click)="changeDefault(defaultExist.value)"
            [value]="bannerForm.value.isDefault == true ? 'yes' : 'no'">
            <mat-button-toggle value="yes" aria-label="yes">
              <mat-icon style="color: green">check</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="no" aria-label="no">
              <mat-icon style="color: red">cancel</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
          <input hidden matInput placeholder="Defecto" formControlName="isDefault">
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha de inicio</mat-label>
            <input id="pickerStart" matInput [matDatepicker]="pickerStart" formControlName="dateFrom">
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha de fin</mat-label>
            <input id="pickerEnd" matInput [matDatepicker]="pickerEnd" formControlName="dateTo">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
          <mat-error *ngIf="convertDate(bannerForm.value.dateTo) < convertDate(bannerForm.value.dateFrom)"
            style="margin-top: -1rem">
            La fecha seleccionada es menor a la fecha actual
          </mat-error>
        </div>
      </div>
    </div>

    <div class="dv-bannerPromo-images">
      <div class="float-banner-button-container">
        <button mat-fab type="button" aria-label="Add" class="float-banner-button" (click)="createBannerPromo();">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="estimateTemplate">
      </ng-container>
    </div>
  </div>
  <div class="bottom-button btn-banner">
    <button class="vs-btn-blue" type="submit" [disabled]="bannerForm.invalid">
      Guardar
    </button>
  </div>
</form>

<ng-template #estimateTemplate>
  <div *ngFor="let item of this.bannerInfo.bannerPromoImages, index as i">
    <div class="row mx-0 my-3 p-0 w-100">
      <div class="col-5 pl-xl-0 mt-2 mb-0" (click)="lastIndexSelected(i)">
        <div class="vs-outline-editCard btn-custom-banner">
          <img width="405px" heigth="320px" class="given-img mb-4" [src]="item.fileImg641 | safeDom" alt="img-banner"
            *ngIf="item.fileImg641">
          <div class="btn-custom-file w-100">
            <label for="file-upload-logo" class="custom-file-upload h-fit-content p-2">
              <mat-icon>{{!item.fileImg641 ? 'image': '' }} </mat-icon>
              <span class="my-2" *ngIf="!item.wrongSize1">
                Elegir imagen Desktop de 1440px x 120px
              </span>
              <span class="mt-5 text-danger" *ngIf="item.wrongSize1">{{item.wrongSize1}}</span>
            </label>
            <input id="file-upload-logo" type="file" accept="image/*"
              (change)="getBase64($event,'item.img1','item.img641',1)" />
          </div>
        </div>
      </div>
      <div class="col-4 pl-xl-0 mt-2 mb-0" (click)="lastIndexSelected(i)">
        <div class="vs-outline-editCard btn-custom-banner">
          <img class="given-img mb-4" [src]="item.fileImg642 | safeDom" alt="img-banner" *ngIf="item.fileImg642">
          <div class="btn-custom-file w-100">
            <label for="file-upload-logo2" class="custom-file-upload h-fit-content p-2">
              <mat-icon>{{!item.fileImg642 ? 'image': '' }} </mat-icon>
              <span class="my-2" *ngIf="!item.wrongSize2">
                Elegir imagen Mobile de 822px x 272px
              </span>
              <span class="mt-5 text-danger" *ngIf="item.wrongSize2">{{item.wrongSize2}}</span>
            </label>
            <input id="file-upload-logo2" type="file" accept="image/*"
              (change)="getBase64($event,'item.img2','item.img642',2)" />
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="mt-2 mb-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>URL a Redireccionar desde Banner</mat-label>
            <input matInput placeholder="URL a Redireccionar desde Banner" [(ngModel)]="item.urlBanner" required>
            <mat-error>Este campo es <b>Requerido</b></mat-error>
          </mat-form-field>
        </div>
        <div class="dv-action-button">
          <span style="margin-right: 30px; margin-top: 5px;">Orden: {{ i + 1 }}</span>
          <button type="button" class="vs-btn-crud" matTooltip="Subir" (click)="moveBannerPromo(i, 1)">
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button type="button" class="vs-btn-crud" matTooltip="Bajar" (click)="moveBannerPromo(i, 2)">
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <button type="button" class="vs-btn-crud" matTooltip="Eliminar Banner" (click)="deleteBannerPromo(i)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>